import { StyleSheet } from 'react-native';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

const commentBodyPaddingLeft = 5;

const dynamicStyles = (colorScheme: ColorScheme, disabledState?: boolean, isLiked?: boolean) =>
    StyleSheet.create({
        container: {
            paddingBottom: 5,
            marginBottom: 5,
            borderRadius: 10,
            paddingVertical: 10,
        },
        handleContainer: {
            width: '100%',
            height: 35,
            flexDirection: 'row',
            borderTopRightRadius: 10,
            borderTopLeftRadius: 10,
            overflow: 'hidden',
        },
        handleLeftContainer: {
            flex: 2,
            justifyContent: 'center',
            alignItems: 'center',
        },
        handleTitleContainer: {
            flex: 5,
            justifyContent: 'center',
            alignItems: 'center',
        },
        handleTitle: {
            fontSize: 14,
            fontWeight: '600',
        },
        handleRightContainer: {
            flex: 2,
            justifyContent: 'center',
            alignItems: 'flex-end',
            paddingRight: 10,
        },
        handleRightIcon: {
            width: 14,
            height: 14,
        },
        detailPostContainer: {
            flex: 1,
            backgroundColor: theme[colorScheme].primary_background,
            paddingTop: 5,
            display: 'flex',
            height: '100%', // TODO Change this value
            flexDirection: 'column',
        },
        commentItemContainer: {
            flexDirection: 'row',
            alignItems: 'flex-start',
        },
        commentItemImageContainer: {
            alignItems: 'center',
        },
        commentItemImage: {
            height: 30,
            width: 30,
            borderRadius: 16,
            marginVertical: 5,
            marginLeft: 5,
        },
        commentItemBodyContainer: {
            flex: 1,
            marginTop: 5,
            // marginBottom: 10,
            backgroundColor: theme[colorScheme].deep_grey_lighter,
            padding: 10,
            borderRadius: 10,
            justifyContent: 'center',
        },
        commentItemBodyRadiusContainer: {
            width: '100%',
            borderRadius: 5,
        },
        commentItemBodyTitle: {
            fontSize: 10,
            fontWeight: '700',
            paddingLeft: commentBodyPaddingLeft,
            fontFamily: FONT_ENUM.MAIN_REGULAR,
            color: theme[colorScheme].lightWhite,
        },
        commentItemBodySubtitle: {
            fontSize: 12,
            paddingVertical: 3,
            paddingLeft: commentBodyPaddingLeft,
            fontFamily: FONT_ENUM.MAIN_REGULAR,
            fontWeight: '400',
            lineHeight: 14,
            color: theme[colorScheme].lightWhite,
        },
        commentInputContainer: {
            flexDirection: 'row',
            width: '100%',
            height: 40,
            justifyContent: 'center',
            alignItems: 'center',
            borderBottomWidth: 0.5,
        },
        commentTextInputContainer: {
            flex: 6,
            height: '90%',
            width: '100%',
            justifyContent: 'center',
            // @ts-ignore
            outlineStyle: 'none',
        },
        commentTextInput: {
            padding: 8,
            color: theme[colorScheme].lightWhite,
            outlineStyle: 'none',
        },
        commentInputIconContainer: {
            justifyContent: 'center',
            marginLeft: 8,
            opacity: disabledState ? 0.3 : 1,
            paddingRight: 10,
            transition: 'display 0.3s ease-in-out',
        },
        commentInputIcon: {
            height: 22,
            width: 22,
        },
        detailsContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            flex: 1,
        },
        replyContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-evenly',
        },
        topReplyContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            minWidth: 100,
            maxWidth: 160,
            marginLeft: 10,
            marginTop: 2,
        },
        reply: {
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            fontSize: 12,
            color: theme[colorScheme].primary_button,
            marginRight: 10,
        },
        like: {
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            fontSize: 12,
            color: isLiked ? theme[colorScheme].switchGreen : theme[colorScheme].primary_button,
            marginRight: 10,
        },
        replyComment: {
            marginLeft: 20,
            marginTop: 5,
        },
        time: {
            fontFamily: FONT_ENUM.MAIN_REGULAR,
            fontSize: 10,
            color: theme[colorScheme].tag_white,
            textTransform: 'capitalize',
            marginRight: 10,
        },
        loader: {
            width: 80,
            height: 80,
            alignSelf: 'center',
        },
        emptyText: {
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            fontSize: 12,
            color: theme[colorScheme].filters_white,
            opacity: 0.7,
            fontWeight: '400',
        },
        emptyTextContainer: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
        },
        wrapper: {
            flex: 1,
            maxWidth: '100%',
            marginLeft: 5,
        },
        showReplies: {
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            fontSize: 12,
            color: theme[colorScheme].primary_button,
            marginLeft: 5,
        },
    });

export { dynamicStyles };
